import { render } from "./OurLocations.vue?vue&type=template&id=638e4f31&scoped=true"
import script from "./OurLocations.vue?vue&type=script&lang=js"
export * from "./OurLocations.vue?vue&type=script&lang=js"

import "./OurLocations.vue?vue&type=style&index=0&id=638e4f31&scoped=true&lang=css"

import exportComponent from "/Users/derem1991/workspace/newear/frontend/theearcasino/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-638e4f31"]])

export default __exports__